import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { TruckIcon, MapMarkerIcon, BoxConditionIcon } from '../../../../assets';
import { theme } from '../../../../theme';
import { WatchButton } from '../../../watchButton';
import { SearchCard } from '../types';
import {
  Price,
  GrayUIText,
  Title,
  StyledBadge,
  ImageContainer,
  Image,
  BottomContent,
  WatchButtonContainer,
  DesktopReserveBarTimerWrapper,
  GrayPrice,
  StyledDeliveryPill,
  SearchCardContainerBase,
  StyledLotBadge,
} from './styles';
import { Timer } from '../../../timer';
import { ReserveBar } from '../../../reserveBar';

const Container = styled(SearchCardContainerBase)`
  width: 234px;
  min-height: 348px;
  display: grid;
  grid-template-rows: 185px 1fr;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  padding: ${theme.spacings[2].rem};
  overflow: hidden;
`;

const DesktopDeliveryPill = styled(StyledDeliveryPill)`
  bottom: ${theme.spacings[2].rem};
  right: ${theme.spacings[2].rem};
`;

const StyledPrice = styled(Price)`
  min-height: 34px;
`;
const BadgesContainer = styled.div`
  position: absolute;
  left: 0;
  top: ${theme.spacings[1].rem};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[1].rem};
`;

export const BaseDesktopSearchCard: React.FC<
  PropsWithChildren<Partial<SearchCard<'Default'>>>
> = ({
  id,
  badgeLabel,
  badgeType,
  imageUrl,
  title,
  grayPrice,
  price,
  condition,
  isDelivery,
  location,
  href,
  children,
  lotId,
  isWatched,
  onWatchButtonClick,
  onClick,
  shippingDiscount,
  timeLeft,
  isWatchable,
  reserveStatus,
  reserveStatusMapping,
  badges,
}) => {
  return (
    <Container
      key={lotId?.toString()}
      id={id?.toString()}
      href={href}
      onClick={onClick}
    >
      <ImageContainer>
        {(badgeLabel || badges) && (
          <BadgesContainer>
            {badgeLabel && <StyledBadge label={badgeLabel} type={badgeType} />}
            {badges &&
              badges.length > 0 &&
              badges.map((badge, i) => (
                <StyledLotBadge
                  key={i}
                  label={badge.label}
                  href={badge.url}
                  altText={badge.title}
                />
              ))}
          </BadgesContainer>
        )}
        <Image width="234px" height="185px" src={imageUrl} alt=""></Image>
        {!!shippingDiscount && (
          <DesktopDeliveryPill
            backgroundColor={theme.colors.primary.graysBlue}
            color={theme.colors.primary.white}
          >
            {shippingDiscount}
          </DesktopDeliveryPill>
        )}
        {isWatchable === true && isWatched !== undefined && (
          <WatchButtonContainer>
            <WatchButton
              lotId={lotId}
              onClick={onWatchButtonClick}
              width={24}
              filled={isWatched}
            />
          </WatchButtonContainer>
        )}
      </ImageContainer>
      {children ? (
        children
      ) : (
        <Content>
          <Title>{title}</Title>
          <DesktopReserveBarTimerWrapper>
            {reserveStatus && (
              <ReserveBar
                reserveStatus={reserveStatus}
                reserveStatusMapping={reserveStatusMapping}
              />
            )}
            <Timer format="long" closingTime={timeLeft} />
          </DesktopReserveBarTimerWrapper>
          <div>
            {grayPrice && <GrayPrice>{grayPrice}</GrayPrice>}
            <StyledPrice>{price}</StyledPrice>
          </div>
          <BottomContent>
            <GrayUIText>
              <BoxConditionIcon
                width={16}
                fill={theme.colors.neutrals.solidGrays[3]}
              />
              {condition}
            </GrayUIText>
            <GrayUIText>
              {isDelivery ? (
                <>
                  <TruckIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  Delivery
                </>
              ) : (
                <>
                  <MapMarkerIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  {location}
                </>
              )}
            </GrayUIText>
          </BottomContent>
        </Content>
      )}
    </Container>
  );
};
